<template>
  <v-layout column>
    <activities-tab-navbar>
      <v-btn
        x-small
        text
        icon
        color="accent"
        @click="exitTabDetails"
        :disabled="task.content && task.content.length <= 0"
      >
        <v-icon>arrow_back_ios</v-icon>
      </v-btn>

      <v-flex class="subheading font-weight-bold">
        {{ $tc("Task", 1) }} {{ task.title }}
      </v-flex>

      <toggle-buttons
        v-model="mode"
        :buttons="toggleButtons"
        style="margin: 6px 8px"
      />
    </activities-tab-navbar>

    <task-form
      v-if="!loading && mode === 'details'"
      :task="task"
      :action-type="actionType"
      :activityUUID="this.activityUUID"
      @update="getTask"
      @delete="exitTabDetails"
      :width="width"
    />

    <div v-if="loading" style="position:relative; width: 100%; height: 100px">
      <loading-spinner
        :active.sync="loading"
        :is-full-page="false"
        color="accent"
        background-color="transparent"
      />
    </div>
  </v-layout>
</template>

<script>
import ActivitiesTabNavbar from "../ActivitiesTabNavbar";
import TaskForm from "./TaskDetailsForm";
import ListEditionToolbar from "@/components/Home/Forms/_Molecules/ListEditionToolbar";
import ToggleButtons from "@/components/_Atoms/AppToggleButtons";
import { mapActions } from "vuex";
import LoadingSpinner from "vue-loading-overlay";

export default {
  name: "ObjectFormTaskDetails",

  components: {
    ToggleButtons,
    ActivitiesTabNavbar,
    ListEditionToolbar,
    TaskForm,
    LoadingSpinner
  },

  props: {
    taskUuid: {
      type: String,
      required: true
    },

    activityUUID: String,
    actionType: String,
    width: Number
  },

  data() {
    return {
      loading: true,
      task: {},
      mode: "details"
    };
  },

  computed: {
    toggleButtons() {
      return [
        /*{ value: "content", text: this.$i18n.t("Map") },*/
        { value: "details", text: this.$i18n.tc("Detail", 2) }
      ];
    }
  },

  mounted() {
    this.getTask();
  },

  methods: {
    ...mapActions(["fetchTask"]),

    async getTask() {
      try {
        this.loading = true;
        this.task = await this.fetchTask({
          taskUUID: this.taskUuid
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    exitTabDetails() {
      this.$emit("return");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/TaskDetails/TaskDetails.vue